import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { SettingApi } from '@/apis';
import { ResponseData } from '@/types/http';
import {
    SETTING_TIME_AUTO_DELETE_ITEM,
    SETTING_DAILY_DROP_LIMIT,
    SETTING_DROPPABLE_RADIUS_M
} from '@/configs/constants';

export default class SettingStore extends BaseStore {
    api: SettingApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            getTimeAutoDelete: flow.bound,
            updateTimeAutoDelete: flow.bound,
            // drop-ux-revamp
            getSettingByKey: flow.bound,
            updateSettingByKey: flow.bound,
            getDailyDropLimit: flow.bound,
            getDroppableRadiusM: flow.bound
        });
        this.api = new SettingApi();
    }

    *getTimeAutoDelete() {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getSystemSetting, { key: SETTING_TIME_AUTO_DELETE_ITEM });
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *updateTimeAutoDelete(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateSetting, payload);
            if (res.ok) {
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    // drop-ux-revamp: 汎用 key→value 取得
    *getSettingByKey(key: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getSystemSetting, { key });
            if (res.ok) return res;
        } catch (error) {
            // noop: fallback 値は呼び出し側で判断
        }
    }

    // drop-ux-revamp: 汎用 update
    *updateSettingByKey(payload: { key: string, value: string | number }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateSetting, payload);
            if (res.ok) return res;
        } catch (error: any) {
            return error?.data;
        }
    }

    *getDailyDropLimit() {
        return yield this.getSettingByKey(SETTING_DAILY_DROP_LIMIT);
    }

    *getDroppableRadiusM() {
        return yield this.getSettingByKey(SETTING_DROPPABLE_RADIUS_M);
    }

    clean(): void {
        super.clean();
    }
}
